// @core/api/endpoints/legalentity/lookup_by_identifier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LookupByIdentifierResponse,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Look up requisites by tax/registration ID
 * Queries the country's registry by an identifier (tax ID or registration number) and returns suggested LegalEntity field values. Read-only; does not persist anything. Used by the create form for autofill.
 */
export async function LookupByIdentifier(
  params?: {
    country?: string | number | boolean;
    id?: string | number | boolean;
    kind?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<LookupByIdentifierResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/lookup`;
  const requestOptions = options;
  return client.get<LookupByIdentifierResponse>(requestPath, { ...requestOptions, params });
}
